// 선택 입력 설문 번호 목록 (survey_seq 기준, 유효성 검사 제외)
export const OPTIONAL_SURVEY_SEQS = ['5', '6', '7', '20', '25', '26', '21', '22', '23', '24'];

// MDL 선택 입력 항목 (survey_seq 기준)
export const OPTIONAL_MDL_SEQS = ['49', '50', '51', '54', '56', '64', '65', '66', '68', '69'];

// 숫자만 입력 가능한 항목 (survey_seq 기준)
export const NUMBER_ONLY_SEQS = ['2', '49', '54', '57', '64', '65', '66', '68'];

const isUnanswered = (q, answers) => {
    const a = answers[q.surveySeq];
    if (q.answerType === 'TEXT')     return !a || a.trim() === '';
    if (q.answerType === 'RADIO')    return !a || a === '' || a === '0';
    if (q.answerType === 'CHECKBOX') return !a || a.length === 0;
    return false;
};

/**
 * 미입력된 첫 번째 필수 설문의 index 반환
 * @returns {number} 미입력 첫 번째 질문의 index, 모두 입력됐으면 -1
 */
export const findFirstUnanswered = (questions, answers) => {
    for (let i = 0; i < questions.length; i++) {
        const q = questions[i];
        if (OPTIONAL_SURVEY_SEQS.includes(String(q.surveySeq))) continue;
        if (isUnanswered(q, answers)) return i;
    }
    return -1;
};

/**
 * 미입력된 모든 필수 설문의 surveySeq 배열 반환
 * @returns {string[]} 미입력 질문의 surveySeq 목록
 */
export const getAllUnansweredSeqs = (questions, answers) => {
    return questions
        .filter(q => !OPTIONAL_SURVEY_SEQS.includes(String(q.surveySeq)) && isUnanswered(q, answers))
        .map(q => q.surveySeq);
};


/**
 * MDL 미입력된 모든 필수 설문의 surveySeq 배열 반환
 * @returns {number[]} 미입력 질문의 surveySeq 목록
 */
export const getAllUnansweredMdlSeqs = (questions, answers) => {
    return questions
        .filter(q => !OPTIONAL_MDL_SEQS.includes(String(q.surveySeq)) && isUnanswered(q, answers))
        .map(q => q.surveySeq);
};
